import { SVGProps, memo } from 'react';
const LinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.88832 8.74094V8.74094C5.67848 7.5311 5.67848 5.56957 6.88832 4.35973L9.07893 2.16912C10.2888 0.959283 12.2503 0.959283 13.4601 2.16912V2.16912C14.67 3.37896 14.67 5.34049 13.4601 6.55033L12.3648 7.64564" stroke={props.color || "#424242"} stroke-width="1.23919" stroke-linecap="round"/>
<path d="M9.07848 6.55008V6.55008C10.2883 7.75992 10.2883 9.72145 9.07848 10.9313L6.88787 13.1219C5.67803 14.3317 3.7165 14.3317 2.50666 13.1219V13.1219C1.29682 11.9121 1.29682 9.95052 2.50666 8.74068L3.60196 7.64538" stroke={props.color || "#424242"} stroke-width="1.23919" stroke-linecap="round"/>
</svg>
);

export default memo(LinkIcon);
